'use client';

import React from 'react';
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from '@vercel/speed-insights/next';
import Tracking from '@/app/shared/utils/tracking/Tracking';

interface AnalyticsWrapperProps {
  children: React.ReactNode;
}

const AnalyticsWrapper: React.FC<AnalyticsWrapperProps> = ({ children }) => {
  return (
    <>
      {children}
      <Analytics />
      <SpeedInsights />
      <Tracking />
    </>
  );
};

export default AnalyticsWrapper;
